import ScrollToTop from './ScrollToTop.view';

export default ScrollToTop;
